// login.js
'use strict';
import addModal from '../action/addModal.js';
import pushToastr from '../action/pushToastr.js';
import getOperationData from '../selector/getOperationData.js';
import { login as loginModal } from '../resource/modalId.js';
import { getIsChinaPartner, getPartnerName } from '../resource/partner.js';
import i18n from '../resource/i18n.js';
import toggleModal from '../action/toggleModal.js';
import { createLoginPromise } from '../resource/loginPromise.js';
/**
 * Login
 * @kind action
 * @param {object} [options] - Login action options.
 * @param {boolean} [options.shouldChooseEntryOption=true] - Whether to open
 * the entry option modal before continuing the login flow.
 * @return {Function} Redux thunk action.
 */

const login =
  ({ shouldChooseEntryOption = true } = {}) =>
  async (dispatch, getState) => {
    if (getIsChinaPartner()) {
      return dispatch(
        pushToastr({
          textKey: 're_login_on_partner',
          textKeyOption: {
            partnerName: i18n.t(getPartnerName()),
          },
          color: 'error',
        })
      );
    }
    const welcomeBackData = getOperationData(getState(), ['welcomeBack']);
    if (shouldChooseEntryOption) {
      const promise = createLoginPromise();
      dispatch(
        toggleModal({
          modalId: loginModal.CHOOSE_ENTRY_OPTION,
          isOpen: true,
          modalOption: {
            isHigherThanAll: true,
          },
        })
      );
      await promise;
    } else if (welcomeBackData?.userId) {
      dispatch(
        addModal({
          id: loginModal.WELCOME_BACK,
          isHigherThanAll: true,
          transitionStatus: 'comingFromBottom',
        })
      );
    } else {
      return dispatch(
        addModal({
          id: loginModal.METHOD_SELECT,
          isHigherThanAll: true,
          transitionStatus: 'comingFromBottom',
        })
      );
    }
  };

export default login;
